import accountRegister from '@/components/account/account-register/account-register.vue';
import accountRegisterFooter from '@/components/account/account-register/footer/footer.vue';

export default {
  components: {
    accountRegister,
    accountRegisterFooter,
  },
};




// WEBPACK FOOTER //
// ./src/components/landing-pages/index1/index1.js